import Vue    from "vue";
import Router from "vue-router";

import Auth              from "../components/Auth";
import Parameters        from "../components/Parameters";
import mainMenu          from "../components/MainMenu";
import Table             from "../components/Table";
import Dashboard         from "../components/Dashboard";
import NewUser           from "../components/NewUser";
import Playlist          from "../components/Playlist";
import PlaylistLeft      from "../components/PlaylistLeft";
import AddNewPlaylist    from "../components/AddNewPlaylist";
import Genre             from "../components/Genre";
import NewChannel        from "../components/NewChannel";
import NewGenre          from "../components/NewGenre";
import TestPage          from "../components/TestPage.vue";
import PlaylistEdit      from "../components/PlaylistEdit";
import Streamers         from "../components/Streamers";
import ExcludedIPTVUsers from "../components/ExcludedIPTVUsers";
import Regions           from "../components/Regions";
import Operators         from "../components/Operators";
import UpdateUsers       from "../components/UpdateUsers";
import EditUserApp       from "../components/EditUserApp";
import streamRating from "../components/streamRating.vue"
Vue.use(Router);

export default new Router({
	// mode: 'history',
	routes: [
		{
			path:       "/menu",
			name:       "mainMenu",
			components: {
				menu: mainMenu
			}
		},
		{
			path:       "/auth",
			name:       "Auth",
			components: {
				auth: Auth
			}
		},
		{
			path:       "/menu/parameters",
			name:       "main",
			components: {
				menu:       mainMenu,
				parameters: Parameters
			}
		},
		{
			path:       "/menu/parameters/table",
			name:       "drawtable",
			components: {
				menu:       mainMenu,
				parameters: Parameters,
				drawtable:  Table
			}
		},
		{
			path:       "/menu/dashboard",
			name:       "dashboard",
			components: {
				menu:      mainMenu,
				dashboard: Dashboard
			}
		},
		{
			path:       "/new-user",
			name:       "newuser",
			components: {
				auth: NewUser
			}
		},
		{
			path:       "/playlist",
			name:       "playlist",
			components: {
				menu:     mainMenu,
				playlist: PlaylistLeft
			}
		},
		{
			path:       "/channel_edit",
			name:       "channel_edit",
			components: {
				menu:     mainMenu,
				playlist: Playlist
			}
		},
		{
			path:       "/add_new_playlist",
			name:       "add_new_playlist",
			components: {
				menu:     mainMenu,
				playlist: AddNewPlaylist
			}
		},
		{
			path:       "/genre",
			name:       "genre",
			components: {
				menu:     mainMenu,
				playlist: Genre
			}
		},
		{
			path:       "/new_channel",
			name:       "new_channel",
			components: {
				menu:     mainMenu,
				playlist: NewChannel
			}
		},
		{
			path:       "/new_genre",
			name:       "new_genre",
			components: {
				menu:     mainMenu,
				playlist: NewGenre
			}
		},
		{
			path:       "/edit_genre",
			name:       "edit_genre",
			components: {
				menu:     mainMenu,
				playlist: NewGenre
			}
		},
		{
			path:       "/test_page",
			name:       "test_page",
			components: {
				menu:     mainMenu,
				playlist: TestPage
			}
		},
		{
			path:       "/playlist_edit",
			name:       "playlist_edit",
			components: {
				menu:     mainMenu,
				playlist: PlaylistEdit
			}
		},
		{
			path:       "/streamers",
			name:       "streamers",
			components: {
				menu:     mainMenu,
				playlist: Streamers
			}
		},
		{
			path:       "/subscribers",
			name:       "subscribers",
			components: {
				menu:     mainMenu,
				playlist: ExcludedIPTVUsers
			}
		},
		{
			path:       "/regions",
			name:       "regions",
			components: {
				menu:     mainMenu,
				playlist: Regions
			}
		},
		{
			path:       "/operators",
			name:       "oprerators",
			components: {
				menu:     mainMenu,
				playlist: Operators
			}
		},
		{
			path:       "/update_users",
			name:       "update_users",
			components: {
				playlist: UpdateUsers
			}
		},
		{
			path:       "/edit_user_app",
			name:       "edit_user_app",
			components: {
				playlist: EditUserApp
			}
		},
		{
			path: "/stream_rating",
			name: "stream_rating",
			components: {
				menu: mainMenu,
				playlist: streamRating
			}
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js